<template>
  <router-view />
</template>

<script>
  export default {
    name: 'TradeXC',
  };
</script>

<style src="./styles/app.scss" lang="scss"/>


